import type { AuthenticatedUser } from '../types/authenticated-user.type';
import { isTokenExpired } from '@/core/utils/jwt.utils';

export function isUserTokenValid(user: AuthenticatedUser): boolean {
  return !isTokenExpired({ value: user.accessToken });
}

export function getUserEmail(user: AuthenticatedUser): string {
  return user.email;
}

export function getUserAvatarUrl(user: AuthenticatedUser): string | undefined {
  return user.avatarUrl;
}

export function userHasPermission(user: AuthenticatedUser, permission: string): boolean {
  return (user.permissions ?? []).includes(permission);
}

export function userHasAnyPermission(user: AuthenticatedUser, permissions: string[]): boolean {
  return permissions.some((p) => (user.permissions ?? []).includes(p));
}

export function userHasAllPermissions(user: AuthenticatedUser, permissions: string[]): boolean {
  return permissions.every((p) => (user.permissions ?? []).includes(p));
}

export function userHasRole(user: AuthenticatedUser, roleName: string): boolean {
  return user.role?.name === roleName;
}
